module.exports = __webpack_public_path__ + "img/er.d3604c84.jpg";